import React, { useState, useEffect, useRef } from 'react'
import {
  Button,
  Grid,
  Column,
  DataTable,
  DatePicker,
  DatePickerInput,
  Loading,
  Link,
  Modal,
  Pagination,
  Select,
  SelectItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TableSelectAll,
  TableSelectRow,
  TextInput,
  RadioButton,
  RadioButtonGroup,
  Row,
  Theme,
} from 'carbon-components-react';
import {
  generateImage,
  getAllValidationResources,
  getValidationInvoice,
  getCountriesList
} from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";
import MessageModal from '../../components/MessageModal/MessageModal';
import SessionController from '../../components/FrontSessionController/SessionController';

const generalHeaders = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'supplier',
    header: 'Supplier',
  },
  {
    key: 'invoice',
    header: 'Invoice',
  },
  {
    key: 'docType',
    header: 'Document Type',
  },
  {
    key: 'order',
    header: 'Order',
  },
  {
    key: 'comm',
    header: 'Comm',
  },
  {
    key: 'curr',
    header: 'Curr',
  },
  {
    key: 'totalAmount',
    header: 'Total Amount',
  },
  {
    key: 'receptionDate',
    header: 'Reception Date',
  },
  {
    key: 'inputDate',
    header: 'Input Date',
  },
  {
    key: 'dueDate',
    header: 'Due Date',
  },
  {
    key: 'filial',
    header: 'Filial',
  },
  {
    key: 'validationDate',
    header: 'Validation Date',
  },
  {
    key: 'lastStatus',
    header: 'Last Status',
  },
  {
    key: 'operatorid',
    header: 'Operator ID',
  },
  {
    key: 'validatorid',
    header: 'Validator ID',
  },
  {
    key: 'description',
    header: 'Description',
  }
];

const modHeaders = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'supplier',
    header: 'Supplier',
  },
  {
    key: 'invoiceOld',
    header: 'Invoice Old',
  }, {
    key: 'invoiceNew',
    header: 'Invoice New',
  },
  {
    key: 'docTypeOld',
    header: 'Document Type Old',
  },
  {
    key: 'docTypeNew',
    header: 'Document Type New',
  }, {
    key: 'OrderOld',
    header: 'Order Old',
  }, {
    key: 'OrderNew',
    header: 'Order New',
  }, {
    key: 'commOld',
    header: 'Commodity Old',
  }, {
    key: 'commNew',
    header: 'Commodity New',
  }, {
    key: 'currOld',
    header: 'Currency Old',
  }, {
    key: 'currNew',
    header: 'Currency New',
  }, {
    key: 'totalAmountOld',
    header: 'Total Amount Old',
  }, {
    key: 'totalAmountNew',
    header: 'Total Amount New',
  }, {
    key: 'receptionDateOld',
    header: 'Reception Date Old',
  }, {
    key: 'receptionDateNew',
    header: 'Reception Date New',
  }, {
    key: 'inputDate',
    header: 'Input Date',
  }, {
    key: 'dueDateOld',
    header: 'Due Date Old',
  }, {
    key: 'dueDateNew',
    header: 'Due Date New',
  }, {
    key: 'filialOld',
    header: 'Filial Old',
  }, {
    key: 'filialNew',
    header: 'Filial New',
  }, {
    key: 'validationDate',
    header: 'Validation Date',
  }, {
    key: 'lastStatus',
    header: 'Last Status',
  }, {
    key: 'operatorid',
    header: 'Operator ID',
  },
  {
    key: 'validatorid',
    header: 'Validator ID',
  },
  {
    key: 'description',
    header: 'Description',
  }
];

const ValidationLog = () => {

  const INITIAL_WARNING_SEARCH_TITLE = "In order to visualize documents you can: "
  const INITIAL_WARNING_SEARCH_OPTION1 = "-Search documents by date choosing an initial and final date within 7 days apart. "
  const INITIAL_WARNING_SEARCH_OPTION2 = "-Search a single document using its invonumb.";


  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [rows, setRows] = useState([]);
  const [attachmentQty, setAttachmentQty] = useState([]);
  const [POList, setPOList] = useState([]);

  const [allType, setAllType] = useState([]);
  const [modifiedRows, setModifiedRows] = useState([]);
  const [rejectedRows, setRejectedRows] = useState([]);
  const [invonumbToGet, setInvonumbToGet] = useState();

  const [firstStep, setFirstStep] = useState(true);
  const [secondStep, setSecondStep] = useState(false);
  const [allRows, setAllRows] = useState({});
  const [lastInvoice, setLastInvoice] = useState({});

  const [countryModal, setCountryModal] = useState(false);
  const [countryChosen, setCountryChosen] = useState();
  const [initDate, setInitDate] = useState();
  const [endDate, setEndDate] = useState();
  const todaysDate = new Date().toISOString().split('T')[0];
  const [maxDateForEndDate, setMaxDateForEndDate] = useState();
  const [countryList, setCountryList] = useState([]);
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [typeSearch, setTypeSearch] = useState('ALL');
  const [headers, setHeaders] = useState(generalHeaders);
  const processingRequest = useRef(false);
  const messageResponse = useRef([]);
  const [messageModal, setMessageModal] = useState('');
  const screenAlreadyOpened = useRef(false);

  const openMessageModal = (response) => {
    let newMessageResponse = [messageResponse.current, <br />, <br />, response];
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);
    messageResponse.current = [];
  }

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  const getCountries = async () => await getCountriesList()
    .then(response => {
      if (response.status === 200) {
        response.json()
          .then(response => {
            response.sort((a, b) => a.countryName.localeCompare(b.countryName));
            setCountryList(response);
          })
      }
    });

  const getAllValidationList = async (request) => {
    if (isRequestActive(true)) {
      return;
    }
    await getAllValidationResources(request)
      .then(response => {
        if (response.status === 200) {
          response.json()
            .then(res => {
              setResponseToAllInvoices(res, request)
            })
        } else if (response.status === 410) {
          response.text()
            .then(res => {
              setMessageSessionLost(res)
            })
        }
      })
    isRequestActive(false);
  };

  const isRequestActive = (enable) => {
    if (enable) {
      if (processingRequest.current) {
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;
      return false;
    } else {
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const setResponseToAllInvoices = (res, request) => {
    parserIdInResponse(res)
    if (res.listInvoiceAllForTable.length === 0 && res.listInvoiceModificatedForTable.length === 0
      && res.listInvoiceRejectedsForTable.length === 0) {
      window.alert("There are no invoices in between dates " + request.fromDate + " and " + request.toDate +
        " for the country " + request.country + ".\nIf you want, try again with other dates.");
    };
  }

  const getInvoice = async (request) => {
    if (isRequestActive(true)) {
      return;
    }
    await getValidationInvoice(request)
      .then(response => {
        if (response.status === 200) {
          response.json()
            .then(res => {
              parserIdInResponseForInvoice(res);
              setLastInvoice(true);
            })
        } else if (response.status === 410) {
          response.text()
            .then(res => {
              setMessageSessionLost(res)
            })
        }
      });
    isRequestActive(false);
  }


  const download = async (request) => {
    if (isRequestActive(true)) {
      return;
    }
    await generateImage(request)
      .then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = response.headers.get('content-disposition');
          a.click();
        });
      });
    isRequestActive(false);
  }

  function downloadInvoice(invonumb, compcode, ctrycode, index) {
    let request = {};
    request.invonumb = invonumb.trim();
    request.ctrycode = ctrycode;
    request.compcode = compcode;
    request.index = index;
    download(request);
  };

  function loadTable(type) {
    if (type === "ALL") {
      setHeaders(generalHeaders)
      setRows(allType);
    } else if (type === "MOD") {
      setHeaders(modHeaders)
      setRows(modifiedRows);
    } else if (type === "REJ") {
      setHeaders(generalHeaders)
      setRows(rejectedRows);
    }
    setTypeSearch(type);
  };

  const parserIdInResponse = (response) => {
    const resParsedAll = response.listInvoiceAllForTable.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.countryCode;
      parsed["compcode"] = res.companyCode;
      parsed["invonumb"] = res.invonumb;
      parsed["supplier"] = res.supplier;
      parsed["invoice"] = res.invoice;
      parsed["docType"] = res.documentType;
      parsed["order"] = res.orden;
      parsed["comm"] = res.commodity;
      parsed["curr"] = res.currency;
      parsed["totalAmount"] = res.total;
      parsed["receptionDate"] = res.receptionDate;
      parsed["inputDate"] = res.inputDate;
      parsed["dueDate"] = res.dueDate;
      parsed["filial"] = res.filial;
      parsed["validationDate"] = res.statusDate;
      parsed["lastStatus"] = res.lastStatus;
      parsed["operatorid"] = res.operatorId;
      parsed["validatorid"] = res.validatorId;
      parsed["description"] = res.description;

      return parsed;
    });

    const resParsedMod = response.listInvoiceModificatedForTable.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.countryCode;
      parsed["compcode"] = res.companyCode;
      parsed["invonumb"] = res.invonumb;
      parsed["supplier"] = res.supplier;
      parsed["invoiceOld"] = res.invoiceOld;
      parsed["invoiceNew"] = res.invoice;
      parsed["docTypeOld"] = res.documentTypeOld;
      parsed["docTypeNew"] = res.documentType;
      parsed["orderOld"] = res.ordenOld;
      parsed["orderNew"] = res.orden;
      parsed["commOld"] = res.commodityOld;
      parsed["commNew"] = res.commodity;
      parsed["currOld"] = res.currencyOld;
      parsed["currNew"] = res.currency;
      parsed["totalAmountOld"] = res.totalOld;
      parsed["totalAmountNew"] = res.total;
      parsed["receptionDateOld"] = res.receptionDateOld;
      parsed["receptionDateNew"] = res.receptionDate;
      parsed["inputDate"] = res.inputDate;
      parsed["dueDateOld"] = res.dueDateOld;
      parsed["dueDateNew"] = res.dueDate;
      parsed["filialOld"] = res.filialOld;
      parsed["filialNew"] = res.filial;
      parsed["validationDate"] = res.fechaEstado;
      parsed["lastStatus"] = res.lastStatus;
      parsed["operatorid"] = res.operatorId;
      parsed["validatorid"] = res.validatorId;
      parsed["description"] = res.description;

      return parsed;
    });

    const resParsedRej = response.listInvoiceRejectedsForTable.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.countryCode;
      parsed["compcode"] = res.companyCode;
      parsed["invonumb"] = res.invonumb;
      parsed["supplier"] = res.supplier;
      parsed["invoice"] = res.invoice;
      parsed["docType"] = res.documentType;
      parsed["order"] = res.orden;
      parsed["comm"] = res.commodity;
      parsed["curr"] = res.currency;
      parsed["totalAmount"] = res.total;
      parsed["receptionDate"] = res.receptionDate;
      parsed["inputDate"] = res.inputDate;
      parsed["dueDate"] = res.dueDate;
      parsed["filial"] = res.filial;
      parsed["validationDate"] = res.statusDate;
      parsed["lastStatus"] = res.lastStatus;
      parsed["operatorid"] = res.operatorId;
      parsed["validatorid"] = res.validatorId;
      parsed["description"] = res.description;

      return parsed;
    });
    setAllType(resParsedAll);
    setModifiedRows(resParsedMod);
    setRejectedRows(resParsedRej);
    setRows(resParsedAll);
    setHeaders(generalHeaders);
    setTypeSearch('ALL')
  };

  const parserIdInResponseForInvoice = (response) => {
    let invoiceUnion = [];
    if (typeSearch === 'MOD') {
      let invoiceInfo = getParseIdInResponseForInvoice(response[0])
      let oldInvoiceInfo = getParseIdInResponseForInvoice(response[1])
      invoiceUnion.push(invoiceInfo);
      invoiceUnion.push(oldInvoiceInfo);
      setAllRows(invoiceUnion);
    } else {
      let invoiceInfo = getParseIdInResponseForInvoice(response[0])
      invoiceUnion.push(invoiceInfo);      
      setAllRows(invoiceUnion);
    }
    console.log(invoiceUnion);
    setAttachmentQty(response[0].invoice.attachmentsQuantity)
    setLastInvoice(false);
  };

  const getParseIdInResponseForInvoice = (invoiceInfoInResponse) => {
    const keysToExtract = ["ctrycode", "compcode", "invonumb", "operator", "validator", "statusDate", "lastStatus",
      "description", "supplierNumber", "invoiceNumber", "documentType", "suffix", "commodity", "netAmount",
      "total", "currency", "receptionDate", "inputDate", "issueDate", "dueDate", "filial", "deliverydate", "hashcodeofinvoice"];
    const parsed = {};
    const resGeneral2 = Object.entries(invoiceInfoInResponse.invoice)
      .filter(([key, value]) => keysToExtract.includes(key))
      .map(([key, value, i = 0]) => {
        if (i === 0) {
          parsed[key] = value;
          i = i + 1;
        } else {
          return "";
        }
        return parsed;
      });

    const resTaxes = invoiceInfoInResponse.invoiceTax.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["taxAmount"] = res.montoiva;
      parsed["taxRate"] = res.tasa;
      parsed["taxCode"] = res.taxCode;
      parsed["taxDescription"] = res.desc;
      parsed["taxableAmount"] = res.baseimpo;
      parsed["taxType"] = res.taxeType;
      parsed["vatType"] = res.vatType;
      return parsed;
    });

    let resPO = [];
    if (invoiceInfoInResponse.orders.length > 0) {
      resPO = invoiceInfoInResponse.orders.map((res, i) => {
        const items = res.lineWithItems.split("-");
        const parsed = {};
        parsed["id"] = i.toString();
        parsed["order"] = items[0].trim();
        parsed["nmbItem"] = items[1].trim();
        parsed["nmbRelease"] = items[2].trim();
        parsed["quantity"] = items[3].trim();
        return parsed;
      });
    } else if (invoiceInfoInResponse.invoiceCredits.length > 0) {
      resPO = invoiceInfoInResponse.invoiceCredits.map((res, i) => {
        const items = res.lineWithItems.split("-");
        const parsed = {};
        parsed["id"] = i.toString();
        parsed["order"] = items[0].trim();
        parsed["nmbItem"] = items[1].trim();
        parsed["nmbRelease"] = items[2].trim();
        parsed["quantity"] = items[3].trim();
        return parsed;
      });
    } else {
      let parsed = {};
      parsed["id"] = " [NO INFO] ";
      parsed["order"] = " [NO PO INFORMATION] ";
      parsed["nmbItem"] = " [NO INFO] ";
      parsed["nmbRelease"] = " [NO INFO] ";
      parsed["quantity"] = " [NO INFO] ";
      resPO.push(parsed);
    }

    let resGeneral = resGeneral2[0];
    resGeneral.taxes = resTaxes;
    resGeneral.po = resPO;

    return resGeneral;
  }

  const goSecondStep = (row) => {
    if (allRows[0] !== undefined) {
      setLastInvoice(allRows[0].invonumb);
    }
    let request = {};
    request.ctrycode = rows[row.id].ctrycode;
    request.compcode = rows[row.id].compcode
    request.invonumb = rows[row.id].invonumb.trim();
    request.status = typeSearch;
    getInvoice(request);
    setFirstStep(false);
    setSecondStep(true);

  };

  const goFirstStep = () => {
    setSecondStep(false);
    setFirstStep(true);
  };

  function closeModal() {
    setCountryModal(false);
  };

  function openModal() {
    setCountryModal(true);
    setCountryChosen("");
  };

  const handleTypeSelect = (e) => {
    const type = e.target.id;
    if (type.includes("country")) {
      setCountryChosen(e.target.value);
    }
  };

  function handleDatePicker(date, type) {
    if (type === ("start")) {
      maxDate(date);
    } else if (type === ("end")) {
      const enddate = new Date(date).toISOString().slice(0, 10);
      setEndDate(enddate);
    }
  };

  function maxDate(date) {
    if (date === undefined) {
      return;
    } else {
      const initdate = new Date(date).toISOString().slice(0, 10);;

      setInitDate(initdate);
      var max = new Date(new Date(initdate).getTime() + 24 * 60 * 60 * 1000 * 8)
      setMaxDateForEndDate(max);
    }

  };

  function submitSearchByDate() {
    let request = {};
    request.fromDate = initDate.replaceAll("/", "-");
    request.toDate = endDate.replaceAll("/", "-");
    request.invonumb = '';
    request.ctrycode = countryChosen;
    request.option = 'date';
    if (request.ctrycode === 'ALL') {
      request.ctrycode = '';
    }

    getAllValidationList(request);
    closeModal();
  };

  function getInvoiceByInvonumb(e) {
    let request = {};
    request.fromDate = '';
    request.toDate = '';
    request.invonumb = invonumbToGet.toUpperCase();
    request.ctrycode = '';
    request.option = 'invonumb';
    getAllValidationList(request);
  };

  const generateLinks = (invonumb, ctrycode, compcode, index) => {
    const linkElements = [];
    for (let i = 0; i <= index; i++) {
      linkElements.push(
        <Link key={i} onClick={() => downloadInvoice(invonumb, ctrycode, compcode, i)}>
          {invonumb}-{i}
        </Link>
      );
    }
    return linkElements;
  };

  const createCSVforExport = (selectedRows) => {
    if (isRequestActive(true)) {
      return;
    }
    let csvtitles = [];
    if (typeSearch === 'MOD') {
      modHeaders.map(e => {
        csvtitles.push(e.header);
      })
    } else {
      generalHeaders.map(e => {
        csvtitles.push(e.header);
      })
    }

    var csvRows = [];
    csvRows.push(csvtitles);

    for (let i = 0; i < selectedRows.length; i++) {
      var uniqueRow = [];
      for (let j = 0; j < selectedRows[i].cells.length; j++) {
        if (selectedRows[i].cells[j].value === undefined || selectedRows[i].cells[j].value.trim() === "") {
          uniqueRow.push("No info");
        } else {
          uniqueRow.push(selectedRows[i].cells[j].value.trim());

        }
      }
      csvRows.push(uniqueRow);
    }
    const csv = csvRows.map(row => row.join(',').replaceAll(",", ";")).join('\n');

    // Create a Blob object for the CSV data
    const blob = new Blob([csv], { type: 'text/csv' });

    // Create a download link for the CSV file
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'data.csv');
    link.click();
    isRequestActive(false);
  }

  const openWarningMessageInSearch = () => {
    if (screenAlreadyOpened.current)
      return;
    openMessageModal(INITIAL_WARNING_SEARCH_TITLE)
    openMessageModal(INITIAL_WARNING_SEARCH_OPTION1)
    openMessageModal(INITIAL_WARNING_SEARCH_OPTION2)
    screenAlreadyOpened.current = true;
  }

  useEffect(() => {
    openWarningMessageInSearch();
    getCountries();
  }, []);


  return (
    <>
      <h2 className="table-title-validationlog">Validation Log</h2>
      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>
        <Modal
          className="selectDate-Modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="SelectDate modal"
          modalAriaLabel="Select Date modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeModal}
          onRequestSubmit={() => submitSearchByDate()}
          onSecondarySubmit={closeModal}
          open={countryModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalHeading={<h3>Search by date</h3>}
        >
          {<p><strong>Search documents by date choosing an initial and a final date within <p className="asterisc"><strong>7</strong></p> days apart</strong></p>}
          <Grid>
            <Column lg={16}>
              <TableHeader>
                <h5 className="select-header-modal">Select a country</h5>
              </TableHeader>
              <Select className="style-select-validation"
                labelText=""
                defaultValue={""}
                id="country"
                onChange={(e) => handleTypeSelect(e)}
              >
                <SelectItem key={'ALL'} value={'ALL'} text={'All Countries'} />
                {countryList.map((country) => (
                  <SelectItem key={country.countryName} value={country.countryCode} text={country.countryName} />
                ))}


              </Select>

              <TableHeader >
                <h5 className="select-header-modal"> Date</h5>
              </TableHeader>
              <DatePicker
                onChange={(date) => handleDatePicker(date, "start")}
                maxDate={todaysDate}
                dateFormat="Y/m/d" locale="en" datePickerType="single" className={"date-picker-delegation"}
              >
                <DatePickerInput id="date-picker-start" labelText="" placeholder="Start date"
                  onChange={e => { setInitDate(e.target.value) }} //si escribis la fecha 2023/01/01, por ej, funciona
                />
              </DatePicker>


              <DatePicker value={endDate}
                onChange={(date) => { handleDatePicker(date, "end") }}
                minDate={initDate}
                maxDate={maxDateForEndDate}
                dateFormat="Y/m/d" locale="en" datePickerType="single" className={"date-picker-delegation"}
              >
                <DatePickerInput id="date-picker-end" labelText="" placeholder="End date"
                  onChange={e => { setEndDate(e.target.value) }} //si escribis la fecha 2023/01/08, por ej, funciona 
                />
              </DatePicker>
            </Column>
          </Grid>

        </Modal>
      </Grid>

      <Grid>
        <Column lg={16} >

          <DataTable
            isSortable={true}
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              selectedRows,
              getHeaderProps,
              getRowProps,
              getTableProps,
              getSelectionProps,
              onInputChange
            }) => (
              <>
                {firstStep && <TableContainer>
                  <Button className='style-bttbackID' size="lg" style={{ marginBottom: '20px' }} onClick={goHomeScreen}>Back to Home</Button>
                  <Grid className="table-menu">
                    <Column className="flex-container2" lg={10}>

                      <RadioButtonGroup legendText={<p><strong>Select</strong></p>} name="select-radio-button" valueSelected={typeSearch}>
                        <RadioButton labelText="All Documents" onClick={() => loadTable("ALL")}
                          value="ALL" id="alldocs" checked={typeSearch === 'ALL' ? true : false} />
                        <RadioButton labelText="Modified Documents" onClick={() => loadTable("MOD")}
                          value="MOD" id="modifieddocs" checked={typeSearch === 'MOD' ? true : false} />
                        <RadioButton labelText="Rejected Documents" onClick={() => loadTable("REJ")}
                          value="REJ" id="rejecteddocs" checked={typeSearch === 'REJ' ? true : false} />
                        <Button className="style-bttSelectDate" onClick={openModal} size="md">Select Date</Button>
                        <Button className="style-bttExport" onClick={() => createCSVforExport(selectedRows)} size="md">Export</Button>

                      </RadioButtonGroup>
                    </Column>
                    <Column className="flex-container2" lg={6}>
                      <TextInput className="style-searchBy" labelText="" id="text-input-1" type="text" placeholder="Search by invonumb" size="md" onChange={e => { setInvonumbToGet(e.target.value) }} />
                      <Button className="style-bttGetDoc" onClick={e => { getInvoiceByInvonumb(e) }} size="md">Get Document</Button>
                    </Column>
                  </Grid>
                  <h5 className='style-moreinfo'>Click on a row to see detailed information</h5>
                  <TableToolbar>
                    <TableToolbarContent>
                      <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                      {/* pass in `onInputChange` change here to make filtering work */}
                    </TableToolbarContent>
                  </TableToolbar>
                  <Table {...getTableProps()} useZebraStyles>
                    <TableHead>
                      <TableRow>
                        <TableSelectAll {...getSelectionProps()} />

                        {headers.map(header => (
                          <>
                            {(header.key === "inputDate" || (header.key === "dueDate")) ? (
                              <TableHeader className="table-header-validation" {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ) : (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            )}

                          </>

                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                        <TableRow  {...getRowProps({ row, i })}>
                          <TableSelectRow  {...getSelectionProps({ row })} />
                          {row.cells.map(cell => (
                            <>
                              {(cell.id.includes("Date")) ? (
                                <TableCell onClick={() => goSecondStep(row)} className="table-row-validation" key={cell.id}>{cell.value}</TableCell>
                              ) : (
                                <TableCell onClick={() => goSecondStep(row)} key={cell.id}>{cell.value}</TableCell>
                              )}

                            </>

                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Pagination
                    onChange={changePaginationState}

                    backwardText="Previous page"
                    forwardText="Next page"
                    itemsPerPageText="Items per page:"
                    page={page}
                    pageNumberText="Page Number"
                    pageSize={pageSize}
                    pageSizes={[
                      10,
                      25,
                      50,
                      100,
                    ]}
                    totalItems={rows.length}
                  />
                </TableContainer>}

                {secondStep && <TableContainer>


                  <Button style={{ margin: '20px' }} size="lg" onClick={goFirstStep}>Back</Button>
                  <Grid className="table-menu">
                    <>
                      {allRows[0] === undefined || allRows[0].invonumb === lastInvoice ?

                        (
                          <Loading
                            description="Active loading indicator" withOverlay={true}
                          />
                        ) : (
                          <React.Fragment >
                            <Column className="flex-container3" lg={7}>

                              {typeSearch !== 'MOD' &&
                                <>
                                  <h3 >General Information</h3>
                                  <Column className="flex-container3" lg={8}>
                                    <Row className={"row-style2"}><h5>Country:</h5> <h5> {(allRows[0].ctrycode)}</h5></Row>
                                    <Row className={"row-style"}><h5>Company:</h5> <h5> {(allRows[0].compcode)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Internal Reference:</h5> <h5> {(allRows[0].invonumb)}</h5></Row>
                                  </Column>
                                </>
                              }
                              <h3 >Log Information</h3>
                              <Column className="flex-container3" lg={8}>
                                {typeSearch === 'MOD' &&
                                  <>
                                    <Row className={"row-style"}><h5>Country:</h5> <h5> {(allRows[0].ctrycode)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Company:</h5> <h5> {(allRows[0].compcode)}</h5></Row>
                                    <Row className={"row-style"}><h5>Internal Reference:</h5> <h5> {(allRows[0].invonumb)}</h5></Row>
                                  </>
                                }
                                <Row className={"row-style2"}><h5>Initial Operator:</h5> <h5> {(allRows[0].operator)}</h5></Row>
                                <Row className={"row-style"}><h5>Validator:</h5> <h5> {(allRows[0].validator)}</h5></Row>
                                <Row className={"row-style2"}><h5>Validation Date:</h5> <h5> {(allRows[0].statusDate)}</h5></Row>
                                <Row className={"row-style"}><h5>State:</h5> <h5> {(allRows[0].lastStatus)}</h5></Row>
                                <Row className={"row-style2"}><h5>Description:</h5> <h5 className='tooLong'>{(allRows[0].description)}</h5></Row>
                              </Column>
                              {typeSearch === 'MOD' &&
                                <>
                                  <h3 >Old Invoice Information</h3>

                                  <Column className="flex-container3" lg={7}>
                                    <Row className={"row-style2"}><h5>Supplier Number:</h5> <h5> {(allRows[1].supplierNumber)}</h5></Row>
                                    <Row className={"row-style"}><h5>Invoice Number:</h5> <h5> {(allRows[1].invoiceNumber)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Document Type:</h5> <h5> {(allRows[1].documentType)}</h5></Row>
                                    <Row className={"row-style"}><h5>Suffix:</h5> <h5> {(allRows[1].suffix)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Commodity:</h5> <h5> {(allRows[1].commodity)}</h5></Row>
                                    <Row className={"row-style"}><h5>Net Amount:</h5> <h5> {(allRows[1].netAmount)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Total Amount:</h5> <h5> {(allRows[1].total)}</h5></Row>
                                    <Row className={"row-style"}><h5>Currency:</h5> <h5>{(allRows[1].currency)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Reception Date:</h5> <h5> {(allRows[1].receptionDate)}</h5></Row>
                                    <Row className={"row-style"}><h5>Input Date:</h5> <h5> {(allRows[1].inputDate)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Issue Date:</h5> <h5> {(allRows[1].issueDate)}</h5></Row>
                                    <Row className={"row-style"}><h5>Due Date:</h5> <h5>{(allRows[1].dueDate)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Filial:</h5> <h5>{(allRows[1].filial)}</h5></Row>
                                    <Row className={"row-style"}><h5>Delivery Date:</h5> <h5>{(allRows[1].deliverydate)}</h5></Row>
                                    <Row className={"row-style2"}><h5>Hash Code From Invoice:</h5> <h5 className='tooLong'>{(allRows[1].hashcodeofinvoice)}</h5></Row>

                                  </Column>

                                  <h3 >Old PO</h3>
                                  <Column className="flex-container3" lg={8}>
                                    <Table useZebraStyles>
                                      <TableHead>
                                        <TableRow>
                                          <TableHeader>ID</TableHeader>
                                          <TableHeader>PO</TableHeader>
                                          <TableHeader>Item</TableHeader>
                                          <TableHeader>Release</TableHeader>
                                          <TableHeader>Quantity</TableHeader>
                                        </TableRow>
                                      </TableHead>

                                      <>
                                        <TableBody className="flex-container3" lg={16}>
                                          <>

                                            {(allRows[1].po.map((row, i) => (
                                              <>
                                                <TableRow>
                                                  <TableCell key={i + 1}>{i + 1}</TableCell>
                                                  <TableCell key={"PO" + i + 1}>{row.order}</TableCell>
                                                  <TableCell key={"Item" + i + 1}>{row.nmbItem}</TableCell>
                                                  <TableCell key={"Release" + i + 1}>{row.nmbRelease}</TableCell>
                                                  <TableCell key={"Quantity" + i + 1}>{row.quantity}</TableCell>
                                                </TableRow>
                                              </>

                                            )))
                                            }
                                          </>
                                        </TableBody>

                                      </>
                                    </Table>
                                  </Column>

                                  <h3 >Old Taxes</h3>
                                  <Column className="flex-container3" lg={8}>
                                    <Table useZebraStyles>
                                      <TableHead>
                                        <TableRow>
                                          <TableHeader>Tax</TableHeader>
                                          <TableHeader>Amount</TableHeader>
                                          <TableHeader>Tax Rate</TableHeader>
                                          <TableHeader>Code</TableHeader>
                                          <TableHeader>Description</TableHeader>
                                          <TableHeader>Taxable Amount</TableHeader>
                                        </TableRow>
                                      </TableHead>
                                      <>
                                        <TableBody className="flex-container3" lg={16}>
                                          {(allRows[1].taxes.filter(row => row.vatType !== 'W').map((row, i) => (
                                            <>
                                              <TableRow>
                                                <TableCell key={i + 1}>{i + 1}</TableCell>
                                                <TableCell key={"taxAmount" + i + 1}>{row.taxAmount}</TableCell>
                                                <TableCell key={"taxRate" + i + 1}>{row.taxRate}</TableCell>
                                                <TableCell key={"taxCode" + i + 1}>{row.taxCode}</TableCell>
                                                <TableCell key={"taxDescription" + i + 1}>{row.taxDescription}</TableCell>
                                                <TableCell key={"taxableAmount" + i + 1}>{row.taxableAmount}</TableCell>
                                              </TableRow>
                                            </>
                                          )))}
                                        </TableBody>
                                      </>
                                    </Table>
                                  </Column>
                                  {(allRows[1].ctrycode !== '631' && allRows[1].taxes.filter(row => row.vatType === 'W').length > 0)&&
                                    <>
                                      <h3 >Old Withholding</h3>
                                      <Column className="flex-container3" lg={8}>
                                        <Table useZebraStyles>
                                          <TableHead>
                                            <TableRow>
                                              <TableHeader>Tax</TableHeader>
                                              <TableHeader>Amount</TableHeader>
                                              <TableHeader>Tax Rate</TableHeader>
                                              <TableHeader>Code</TableHeader>
                                              <TableHeader>Description</TableHeader>
                                              <TableHeader>Taxable Amount</TableHeader>
                                            </TableRow>
                                          </TableHead>
                                          <>
                                            <TableBody className="flex-container3" lg={16}>
                                              {(allRows[1].taxes.filter(row => row.vatType === 'W').map((row, i) => (
                                                <>
                                                  <TableRow>
                                                    <TableCell key={i + 1}>{i + 1}</TableCell>
                                                    <TableCell key={"taxAmount" + i + 1}>{row.taxAmount}</TableCell>
                                                    <TableCell key={"taxRate" + i + 1}>{row.taxRate}</TableCell>
                                                    <TableCell key={"taxCode" + i + 1}>{row.taxCode}</TableCell>
                                                    <TableCell key={"taxDescription" + i + 1}>{row.taxDescription}</TableCell>
                                                    <TableCell key={"taxableAmount" + i + 1}>{row.taxableAmount}</TableCell>
                                                  </TableRow>
                                                </>
                                              )))}
                                            </TableBody>
                                          </>
                                        </Table>
                                      </Column>
                                    </>
                                  }
                                </>
                              }
                            </Column>

                            <Column className="flex-container3" lg={7} >
                              {typeSearch !== 'MOD' ? (
                                <h3 >Invoice Information</h3>
                              ) : (
                                <h3 style={{ marginTop: '280px' }}>New Invoice Information</h3>
                              )}
                              <Column className="flex-container3" lg={7}>
                                <Row className={"row-style2"}><h5>Supplier Number:</h5> <h5> {(allRows[0].supplierNumber)}</h5></Row>
                                <Row className={"row-style"}><h5>Invoice Number:</h5> <h5> {(allRows[0].invoiceNumber)}</h5></Row>
                                <Row className={"row-style2"}><h5>Document Type:</h5> <h5> {(allRows[0].documentType)}</h5></Row>
                                <Row className={"row-style"}><h5>Suffix:</h5> <h5> {(allRows[0].suffix)}</h5></Row>
                                <Row className={"row-style2"}><h5>Commodity:</h5> <h5> {(allRows[0].commodity)}</h5></Row>
                                <Row className={"row-style"}><h5>Net Amount:</h5> <h5> {(allRows[0].netAmount)}</h5></Row>
                                <Row className={"row-style2"}><h5>Total Amount:</h5> <h5> {(allRows[0].total)}</h5></Row>
                                <Row className={"row-style"}><h5>Currency:</h5> <h5>{(allRows[0].currency)}</h5></Row>
                                <Row className={"row-style2"}><h5>Reception Date:</h5> <h5> {(allRows[0].receptionDate)}</h5></Row>
                                <Row className={"row-style"}><h5>Input Date:</h5> <h5> {(allRows[0].inputDate)}</h5></Row>
                                <Row className={"row-style2"}><h5>Issue Date:</h5> <h5> {(allRows[0].issueDate)}</h5></Row>
                                <Row className={"row-style"}><h5>Due Date:</h5> <h5>{(allRows[0].dueDate)}</h5></Row>
                                <Row className={"row-style2"}><h5>Filial:</h5> <h5>{(allRows[0].filial)}</h5></Row>
                                <Row className={"row-style"}><h5>Delivery Date:</h5> <h5>{(allRows[0].deliverydate)}</h5></Row>
                                <Row className={"row-style2"}><h5>Hash Code From Invoice:</h5> <h5 className='tooLong'>{(allRows[0].hashcodeofinvoice)}</h5></Row>

                              </Column>

                              {typeSearch !== 'MOD' ? (
                                <h3 >PO</h3>
                              ) : (
                                <h3>New PO</h3>
                              )}
                              <Column className="flex-container3" lg={8}>
                                <Table useZebraStyles>
                                  <TableHead>
                                    <TableRow>
                                      <TableHeader>ID</TableHeader>
                                      <TableHeader>PO</TableHeader>
                                      <TableHeader>Item</TableHeader>
                                      <TableHeader>Release</TableHeader>
                                      <TableHeader>Quantity</TableHeader>
                                    </TableRow>
                                  </TableHead>

                                  <>
                                    <TableBody className="flex-container3" lg={16}>
                                      <>
                                        {
                                          (allRows[0].po.map((row, i) => (
                                            <>
                                              <TableRow>
                                                <TableCell key={i + 1}>{i + 1}</TableCell>
                                                <TableCell key={"PO" + i + 1}>{row.order}</TableCell>
                                                <TableCell key={"Item" + i + 1}>{row.nmbItem}</TableCell>
                                                <TableCell key={"Release" + i + 1}>{row.nmbRelease}</TableCell>
                                                <TableCell key={"Quantity" + i + 1}>{row.quantity}</TableCell>
                                              </TableRow>
                                            </>

                                          )))
                                        }
                                      </>
                                    </TableBody>

                                  </>
                                </Table>
                              </Column>

                              {typeSearch !== 'MOD' ? (
                                <h3>Vats</h3>
                              ) : (
                                <h3>New Vats</h3>
                              )}
                              <Column className="flex-container3" lg={8}>
                                <Table useZebraStyles>
                                  <TableHead>
                                    <TableRow>
                                      <TableHeader>Tax</TableHeader>
                                      <TableHeader>Amount</TableHeader>
                                      <TableHeader>Tax Rate</TableHeader>
                                      <TableHeader>Code</TableHeader>
                                      <TableHeader>Description</TableHeader>
                                      <TableHeader>Taxable Amount</TableHeader>
                                    </TableRow>
                                  </TableHead>
                                  <>
                                    <TableBody className="flex-container3" lg={16}>
                                      {(allRows[0].taxes
                                        .filter(row => row.vatType !== "W")
                                        .map((row, i) => (
                                          <>
                                            
                                            <TableRow>
                                              <TableCell key={i + 1}>{i + 1}</TableCell>
                                              <TableCell key={"taxAmount" + i + 1}>{row.taxAmount}</TableCell>
                                              <TableCell key={"taxRate" + i + 1}>{row.taxRate}</TableCell>
                                              <TableCell key={"taxCode" + i + 1}>{row.taxCode}</TableCell>
                                              <TableCell key={"taxDescription" + i + 1}>{row.taxDescription}</TableCell>
                                              <TableCell key={"taxableAmount" + i + 1}>{row.taxableAmount}</TableCell>
                                            </TableRow>
                                            
                                          </>
                                        )))}
                                    </TableBody>
                                  </>
                                </Table>
                              </Column>
                              {(allRows[0].ctrycode !== '631' && allRows[0].taxes.filter(row => row.vatType === 'W').length > 0) &&
                                <>

                                  {typeSearch !== 'MOD' ? (
                                    <h3>Withholdings</h3>
                                  ) : (
                                    <h3>New Withholdings</h3>
                                  )}

                                  <Column>
                                    <Column className="flex-container3" lg={8}>
                                      <Table useZebraStyles>
                                        <TableHead>
                                          <TableRow>
                                            <TableHeader>Tax</TableHeader>
                                            <TableHeader>Amount</TableHeader>
                                            <TableHeader>Tax Rate</TableHeader>
                                            <TableHeader>Code</TableHeader>
                                            <TableHeader>Description</TableHeader>
                                            <TableHeader>Taxable Amount</TableHeader>
                                          </TableRow>
                                        </TableHead>
                                        <>
                                          <TableBody className="flex-container3" lg={16}>
                                            {(allRows[0].taxes
                                              .filter(row => row.vatType === "W")
                                              .map((row, i) => (
                                                <>
                                                  <TableRow>
                                                    <TableCell key={i + 1}>{i + 1}</TableCell>
                                                    <TableCell key={"taxAmount" + i + 1}>{row.taxAmount}</TableCell>
                                                    <TableCell key={"taxRate" + i + 1}>{row.taxRate}</TableCell>
                                                    <TableCell key={"taxCode" + i + 1}>{row.taxCode}</TableCell>
                                                    <TableCell key={"taxDescription" + i + 1}>{row.taxDescription}</TableCell>
                                                    <TableCell key={"taxableAmount" + i + 1}>{row.taxableAmount}</TableCell>
                                                  </TableRow>
                                                </>
                                              )))}
                                          </TableBody>
                                        </>
                                      </Table>
                                    </Column>
                                  </Column>
                                </>
                              }
                            </Column>
                            <Column className="flex-container3" lg={2}>
                              <h3 >Download</h3>
                              <>
                                {generateLinks(allRows[0].invonumb, allRows[0].compcode, allRows[0].ctrycode, attachmentQty)}
                              </>
                            </Column>

                          </React.Fragment>
                        )}
                    </>


                  </Grid>


                </TableContainer>}
              </>


            )}
          />
          <SessionController messageLostSessionCallback={messageSessionLost} />
          <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal} />
        </Column>
      </Grid>
    </>
  );
};

export default ValidationLog;